/* キャンペーン追従バナー。テーマエディタでのセクション再読み込みにも対応する。 */
(() => {
  const root = document.documentElement;
  const reveal = (scope) => {
    const banners = scope.matches?.('[data-sticky-banner]')
      ? [scope]
      : scope.querySelectorAll('[data-sticky-banner]');

    banners.forEach((banner) => {
      const items = banner.querySelectorAll('[data-sticky-banner-item]');
      items.forEach((item) => {
        let dismissed = false;
        try {
          dismissed = sessionStorage.getItem(item.dataset.storageKey) === '1';
        } catch (error) {
          // プライベートブラウズなどで保存できない場合も表示する。
        }
        item.hidden = !(window.Shopify?.designMode) && dismissed;
      });
      banner.hidden = [...items].every((item) => item.hidden);
    });
  };

  if (root.dataset.customStickyBannerBound === 'true') {
    if (document.readyState !== 'loading') reveal(document);
    return;
  }
  root.dataset.customStickyBannerBound = 'true';

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const close = event.target.closest('[data-sticky-banner-close]');
    if (!close) return;
    const item = close.closest('[data-sticky-banner-item]');
    const banner = item?.closest('[data-sticky-banner]');
    if (!item || !banner) return;

    item.hidden = true;
    try {
      sessionStorage.setItem(item.dataset.storageKey, '1');
    } catch (error) {
      // 保存できなくても、その場では閉じる。
    }
    banner.hidden = [...banner.querySelectorAll('[data-sticky-banner-item]')].every((entry) => entry.hidden);
  });

  document.addEventListener('shopify:section:load', (event) => reveal(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => reveal(document), { once: true });
  } else {
    reveal(document);
  }
})();
